// Add your custom JS here.
(function($) {
    jQuery(document).ready(function() {
        // gsap.registerPlugin(ScrollTrigger);
        // gsap.registerPlugin(ScrollToPlugin);

        // smooth anchor scroll
        function scrollToAnchor(aid){
            const destination = $(aid);
            $('html,body').animate({
                scrollTop: destination.offset().top
            },'slow');
        }
    
        $(document).on('click', '.smooth-scroll', function(){
            scrollToAnchor($(this).attr('href'));
        });

        function makeParalaxx(){
            $('.page-header-image').jarallax({
                speed: 0.2,
                disableParallax: function(){
                    var is_mobile =  window.matchMedia("only screen and (max-width: 768px)").matches;
                    console.log(is_mobile);
                    return is_mobile;
                }
                // imgSize: 'contain'
               // imgSize: '100%'
            });
        }
        makeParalaxx();
        

        // $( window ).on( "resize", function() {
        //     // $( "#log" ).append( "<div>Handler for `resize` called.</div>" );
        //     var is_mobile =  window.matchMedia("only screen and (max-width: 768px)").matches;
        //     if(is_mobile){
        //         $('.page-header-image').jarallax('destroy');
        //     } else {
        //         // console.log($('.page-header-image').jarallax().count);
        //         makeParalaxx();
        //     }
        // });

        $("#frontpage-banner h1").lettering();

        // $('#frontpage-banner h1').lettering().children('span').each(function(){
        //     console.log(this);
        //     $(this).data('char', $(this).text() );
        //   });

        // let beat = new Audio('/wp-content/audio/piano-g-6200.mp3');

        

        $('#frontpage-banner h1 > span.char').on('click', function(){
            // console.log(this);

            var cid = $(this).data('num');

            // console.log(cid);
            audio[cid].play();
            // beat.play();
        })


        // Facet WP
        $(document).on('facetwp-loaded', function() {
            var qs = FWP.buildQueryString();
            if ( '' === qs ) { // no facets are selected
                $('.facetwp-reset').addClass('active');
            }
            else {
                $('.facetwp-reset').removeClass('active');
            }
        });

        $(document).on('facetwp-refresh', function() {
            if ( FWP.soft_refresh == true )  {
                FWP.enable_scroll = true;
            } else {
                FWP.enable_scroll = false;
            }
        });

        $(document).on('facetwp-loaded', function() {
            if (FWP.enable_scroll == true) {
                $('html, body').animate({
                    scrollTop: $('.facetwp-template').offset().top
                }, 500);
            }
        });

        // Facet WP
        // if ('object' != typeof FWP) {
        //     return;
        // } else {
        //      /* Modify the flyout wrapper HTML */
        //   FWP.hooks.addFilter('facetwp/flyout/flyout_html', function(flyout_html) {
        //     return flyout_html.replace(' <div class="facetwp-flyout-close">x</div>', ' <button class="btn-close text-reset btn-close-white facetwp-flyout-close" type="button" aria-label="Menü schließen"></button>'); // Replace "Close" with your desired text
        //   });
        // };


        ScrollTrigger.create({
            trigger: '#wrapper-navbar',
            start: "bottom 90%",
            // markers: true,
            onEnter: (self) => goToSection('#wrapper-navbar')
          });

          ScrollTrigger.create({
            trigger: '#frontpage-banner',
            start: "bottom 70%",
            // markers: true,
            onToggle: ({progress, direction, isActive}) => checkBanner(progress, direction, isActive)
            // onEnter: (self) => function (self){
            //     console.log(self);
            //     goToSection('#frontpage-banner')
            // }
          });

          function checkBanner(progress, direction, isActive){
            // console.log('check');
            // console.log(progress, direction, isActive);
            if(direction == -1){
                goToSection('#frontpage-banner');
            }
          }
        // ScrollTrigger.create({
        //     trigger: "#page",
        //     start: "top top",
        //     // snap: 0.1,
        //     // endTrigger: "#otherID",
        //     // end: "bottom 50%+=100px",
        //     markers: true,
        //     onToggle: (self) => console.log("toggled, isActive:", self.isActive),
        //     onUpdate: (self) => {
        //         console.log(
        //         "progress:",
        //         self.progress.toFixed(3),
        //         "direction:",
        //         self.direction,
        //         "velocity",
        //         self.getVelocity()
        //         );
        //     },
        // });

        function goToSection(i) {
            // console.log(i);
            var scTop = $(i).position();
            // console.log($(i).position());
            gsap.to(window, {
              scrollTo: { y: scTop.top, autoKill: false, ease: "bounce" },
              duration: 0.85
            });
          }



    // });
        // console.log($('.my-media-player'));

        // function myGreeting(){
        //     console.log('to');
        //     return true;
        // }
        // console.log('test 2');
        // var  myTimeout = setTimeout(myGreeting, 1000);
        // console.log(myTimeout);

        // function myStopFunction() {
        // clearTimeout(myTimeout);
        // }

        // setTimeout(function(){ 
        //     console.log('time 1');
        //     // new MediaElementPlayer(mediaElements[i], {
        //     //     autoRewind: false,
        //     //     features: features,
        //     // });
        // }, 1000);


        // var mediaElements = document.querySelectorAll('.my-media-player');

        // for (var i = 0, total = mediaElements.length; i < total; i++) {

        //     var features = ['playpause', 'progress', 'loop', 'stop', 'contextmenu', 'fullscreen'];

        //     // setTimeout(function(){ 
        //     //     console.log('time');
        //     //     // new MediaElementPlayer(mediaElements[i], {
        //     //     //     autoRewind: false,
        //     //     //     features: features,
        //     //     // });
        //     // }, 1000);

        //     new MediaElementPlayer(mediaElements[i], {
        //         autoRewind: false,
        //         features: features,
        //     });
        // }

        $('ul.media li a').on('click', function(){
            $("#danke").modal("show");
        });

        
        $('.pop-media-player').mediaelementplayer({
            features: ['playpause','progress'],
            success: function(player, node) {
                console.log('test');
                // Optional
                // $(player).closest('.mejs__container').attr('lang', mejs.i18n.language());

                // $('html').attr('lang', mejs.i18n.language());

                // More code
            },
            audioWidth: 200,
            setDimensions: false
        });

        $.contextMenu({
            // define which elements trigger this menu
            selector: ".pop-media-player",
            // define the elements of the menu
            items: {
                download: {name: "Download mp3", callback: function(key, opt, e){ 
                    // console.log(key);
                    // console.log(opt['$trigger']);
                    console.log(opt);
                    var url = $(opt['$trigger']).find('audio').data('download');
                    forceDownload(url);

                    console.log(url);
                 }},
               //  bar: {name: "Bar", callback: function(key, opt){ alert("Bar!") }}
            }
            // there's more, have a look at the demos and docs...
        });

        function forceDownload(href) {
            $("#danke").modal("show");
            var anchor = document.createElement('a');
            var filename = href.substring(href.lastIndexOf('/')+1);
            anchor.href = href;
            anchor.download = filename;
            document.body.appendChild(anchor);
            anchor.click();
            document.body.removeChild(anchor);
        }

        // $('.pop-media-player').contextmenu(function (e) { console.log($(e.target)) })


    });
}(jQuery, window));